function fetchConfig(type = 'json') {
  var contentType = 'application/' + type;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: contentType,
    },
  };
}
const listProductTypeOrnaments = ['Custom Shaped Acrylic Ornament','Wooden Ornament','Family Wood Ornament','Acrylic Ornament','Circle Acrylic Ornament','Ceramic Ornament'];
const RULES_META_COLLECTIONS = {
      BF50FB: 'Personalized Blanket',
      BF42FB: 'Holiday Ornaments',
    };
function getCookieByProduct(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
window._AutofillCallbackHandler =
  window._AutofillCallbackHandler || function () {};
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      if (summary.closest('.mc-filters__group')) return;
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    });
    this.querySelectorAll('button:not(.localization-selector)').forEach(
      (button) => {
        if (button.closest('.mc-filters__group')) return;
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      },
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary'),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        const elementLink = summaryElement.querySelector('a[href]')
        if(!elementLink){
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
        }
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent && elementToFocus)
      elementToFocus.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`,
    );
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((btn) => {
      btn.addEventListener('click', this.hide.bind(this, false));
    });
    this.addEventListener('keyup', (event) => {
      if (event?.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(debounce(() => this.initPages(), 200));
    resizeObserver.observe(this.slider);

    let scrollTicking = false;
    this.slider.addEventListener('scroll', () => {
      if (!scrollTicking) {
        scrollTicking = true;
        requestAnimationFrame(() => {
          this.update();
          scrollTicking = false;
        });
      }
    }, { passive: true });
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    if (element) {
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (this.slider) {
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (!this.sliderItemsToShow || !this.sliderItemsToShow.length) {
        this.sliderItemsToShow = Array.from(this.querySelectorAll('[id^="Slide-"]')).filter(
          (el) => el.clientWidth > 0,
        );
      }
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
      if (this.sliderItemsToShow.length > 1) {
        this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      }
    }

    // auto play (only when more than 1 slide)
    if (this.slider.getAttribute('data-autoplay') === 'true' && this.sliderItemsToShow && this.sliderItemsToShow.length > 1) {
      this.setAutoPlay();
    }

    // Touch swipe for mobile - same logic as next/prev buttons
    if (this.slider && this.sliderItemsToShow && this.sliderItemsToShow.length > 1) {
      let touchStartX = 0;

      this.slider.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        if (this.autoplay) clearInterval(this.autoplay);
      }, { passive: true });

      this.slider.addEventListener('touchend', (e) => {
        if (this.isLoopAnimating) return;
        const touchEndX = e.changedTouches[0].clientX;
        const swipedLeft = touchStartX - touchEndX > 30;
        const swipedRight = touchEndX - touchStartX > 30;
        // Sync currentPage from actual scroll position
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        if (swipedLeft) {
          if (this.currentPage >= this.sliderItemsToShow.length) {
            this.seamlessLoopForward();
          } else {
            this.setSlidePosition(this.slider.scrollLeft + this.sliderItemOffset);
          }
        } else if (swipedRight) {
          if (this.currentPage <= 1) {
            this.seamlessLoopBackward();
          } else {
            this.setSlidePosition(this.slider.scrollLeft - this.sliderItemOffset);
          }
        }

        this.userInteracted = true;
        this.pauseAndRestart();
      }, { passive: true });
    }

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      );
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true')
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener(
        'click',
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
    }
    this.play();
  }

  onButtonClick(event) {
    if (this.isLoopAnimating) {
      event.preventDefault();
      return;
    }
    // Stop autoplay on manual interaction
    this.userInteracted = true;
    this.pauseAndRestart();

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isLastSlide && event.currentTarget.name === 'next') {
      event.preventDefault();
      this.wasClicked = true;
      this.seamlessLoopForward();
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    } else if (isFirstSlide && event.currentTarget.name === 'previous') {
      event.preventDefault();
      this.wasClicked = true;
      this.seamlessLoopBackward();
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    } else {
      super.onButtonClick(event);
      this.wasClicked = true;
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    }
  }

  animateScroll(targetPosition, duration, callback) {
    const startPosition = this.slider.scrollLeft;
    const distance = targetPosition - startPosition;
    let startTime = null;

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = progress * (2 - progress);
      this.slider.scrollLeft = startPosition + distance * ease;

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        if (callback) callback();
      }
    };
    requestAnimationFrame(animation);
  }

  seamlessLoopForward() {
    this.isLoopAnimating = true;
    
    const firstClone = this.sliderItems[0].cloneNode(true);
    firstClone.classList.add('temp-clone');
    firstClone.removeAttribute('id');
    
    this.slider.style.scrollBehavior = 'auto';
    this.slider.style.scrollSnapType = 'none';
    this.slider.style.overflowAnchor = 'none';
    this.slider.appendChild(firstClone);
    
    void this.slider.offsetHeight;
    
    setTimeout(() => {
      const clonePosition = this.slider.scrollWidth - this.slider.clientWidth;
      
      this.animateScroll(clonePosition, window.innerWidth >= 768 ? 1200 : 500, () => {
        this.slider.style.scrollBehavior = 'auto';
        this.slider.scrollLeft = 0;
        firstClone.remove();
        void this.slider.offsetHeight;
        
        this.slider.style.scrollBehavior = '';
        this.slider.style.scrollSnapType = ''; 
        this.slider.style.overflowAnchor = '';
        
        this.isLoopAnimating = false;
        this.update();
      });
    }, 30 + this.announcerBarAnimationDelay);
  }

  seamlessLoopBackward() {
    this.isLoopAnimating = true;
    
    const lastClone = this.sliderItems[this.sliderItems.length - 1].cloneNode(true);
    lastClone.classList.add('temp-clone');
    lastClone.removeAttribute('id');
    
    this.slider.style.scrollBehavior = 'auto';
    this.slider.style.overflowAnchor = 'none';
    this.slider.style.scrollSnapType = 'none';
    
    this.slider.insertBefore(lastClone, this.sliderItems[0]);
    
    const offset = this.sliderItemOffset || lastClone.clientWidth;
    this.slider.scrollLeft = offset;
    void this.slider.offsetHeight;
    
    setTimeout(() => {
      this.animateScroll(0, window.innerWidth >= 768 ? 1200 : 500, () => {
        this.slider.style.scrollBehavior = 'auto';
        lastClone.remove();
        this.slider.scrollLeft = this.slider.scrollWidth;
        void this.slider.offsetHeight;
        
        this.slider.style.scrollBehavior = '';
        this.slider.style.overflowAnchor = '';
        this.slider.style.scrollSnapType = '';
        
        this.isLoopAnimating = false;
        this.update();
      });
    }, 30 + this.announcerBarAnimationDelay);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      // Add the 3 inline styles for animation
      this.slider.style.scrollBehavior = 'auto';
      this.slider.style.scrollSnapType = 'none';
      this.slider.style.overflowAnchor = 'none';

      this.animateScroll(position, window.innerWidth >= 768 ? 1200 : 500, () => {
        this.slider.style.scrollBehavior = '';
        this.slider.style.scrollSnapType = '';
        this.slider.style.overflowAnchor = '';
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    if (this.isLoopAnimating) return;
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.prevButton) this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;
    // Clamp currentPage to valid range
    const pageIndex = Math.max(0, Math.min(this.currentPage - 1, this.sliderControlButtons.length - 1));
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[pageIndex].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[pageIndex].setAttribute(
      'aria-current',
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.userInteracted) return;
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      this.reducedMotion &&
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider && this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  pauseAndRestart() {
    this.pause();
    if (this._restartTimer) clearTimeout(this._restartTimer);
    this._restartTimer = setTimeout(() => {
      this.userInteracted = false;
      if (this.autoplaySpeed) this.play();
    }, 1000);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    if (this.isLoopAnimating) return;
    if (this.currentPage === this.sliderItems.length) {
      // At last slide, use seamless forward loop
      this.seamlessLoopForward();
    } else {
      const slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset;
      this.setSlidePosition(slideScrollPosition);
    }
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === 'next' && !isLastSlide) ||
      (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    this.userInteracted = true;
    this.pauseAndRestart();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.setSlidePosition(slideScrollPosition);
  }
}

customElements.define('slideshow-component', SlideshowComponent);
let selectedOptions = [];

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.addEventListener('change', this.rebuildOptions);
    this.rebuildOptions();
  }
  rebuildOptions() {
    const pickerType = document.querySelector('variant-radios')
      ? 'radios'
      : 'selects';
    const variantSelects =
      pickerType == 'radios'
        ? document.querySelector('variant-radios')
        : document.querySelector('variant-selects');
    if (!variantSelects) {
      return;
    }
    const fieldsets =
      pickerType == 'radios'
        ? Array.from(variantSelects.querySelectorAll('fieldset'))
        : Array.from(
            variantSelects.querySelectorAll('.product-form__input--dropdown'),
          );
    selectedOptions = fieldsets.map((fieldset) => {
      return pickerType == 'radios'
        ? Array.from(fieldset.querySelectorAll('input')).find(
            (radio) => radio.checked,
          ).value
        : Array.from(
            fieldset.querySelectorAll('select'),
            (select) => select.value,
          );
    });

    //loop through the option sets starting from the 2nd set and disable any invalid options
    for (
      let optionLevel = 1, n = fieldsets.length;
      optionLevel < n;
      optionLevel++
    ) {
      const inputs =
        pickerType == 'radios'
          ? fieldsets[optionLevel].querySelectorAll('input')
          : fieldsets[optionLevel].querySelectorAll('option');

      inputs.forEach((input) => {
        input.disabled = this.validCombo(input.value, optionLevel)
          ? false
          : true;
        if (pickerType == 'radios') {
          const label = fieldsets[optionLevel].querySelector(
            `label[for="${input.id}"]`,
          );

          label.style.display = input.disabled ? 'none' : '';

          input.hidden = this.validCombo(input.value, optionLevel)
            ? false
            : true;
        }
      });
    }

    for (
      let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
      optionLevel < fieldsetsLength && !change;
      optionLevel++
    ) {
      if (pickerType == 'radios') {
        if (
          fieldsets[optionLevel].querySelector('input:checked').disabled ===
          true
        ) {
          if (fieldsets[optionLevel].querySelector('input:not(:disabled)')) {
            const inputHidden = fieldsets[optionLevel].querySelector(
              'input[checked][disabled]',
            );
            if (inputHidden) {
              inputHidden.removeAttribute('checked');
            }
            const input = fieldsets[optionLevel].querySelector(
              'input:not(:disabled)',
            );
            input.checked = true;
            //this.onVariantChange()
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            input.dispatchEvent(evt);
            change = input;
          }
        }
      } else {
        if (
          fieldsets[optionLevel].querySelector('option:checked').disabled ===
          true
        ) {
          change = fieldsets[optionLevel].querySelector(
            'option:not(:disabled)',
          ).selected = 'selected';
        }
      }
      //if a new option has been selected, restart the whole process
      if (change)
        variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  validCombo(inputValue, optionLevel) {
    const pickerType = document.querySelector('variant-radios')
      ? 'radios'
      : 'selects';
    const variantSelects =
      pickerType == 'radios'
        ? document.querySelector('variant-radios')
        : document.querySelector('variant-selects');
    const productJson = JSON.parse(
      variantSelects.querySelector('[type="application/json"]').textContent,
    );

    const typeProduct = document.querySelector('#product_type').textContent;
    const styles = ['Classic Tee', 'Sweater', 'Pullover Hoodie'];
    const country = getCookieByProduct('code_country');
    const colorSand = 'Sand';
    const colorFilter = ['Sport Grey', 'White', 'Black'];
    const sizeFilter = ['4XL', '5XL'];
    const sizeCanvas = ['24" x 36"', '36" x 24"'];
    const typeCanvas = 'Canvas';
    const sizePoster = ['11"x14"', '14"x11"', '8"x12"', '12"x8"'];
    const typePoster = 'Poster';
    const sizeCard = ['5" x 7"', '7" x 5"'];
    const pack = '1 Card';
    const typeProductEmbroidered = 'Embroidered Shirt';

    if (country == 'US' || typeProduct == typeProductEmbroidered) {
      return true;
    }

    for (let i = 0; i < productJson.length; i++) {
      if (optionLevel == 1) {
        if (
          colorSand == inputValue ||
          (typeCanvas == selectedOptions[0] &&
            sizeCanvas.includes(inputValue.replace(/\s/g, ''))) ||
          (typePoster == selectedOptions[0] &&
            sizePoster.includes(inputValue.replace(/\s/g, ''))) ||
          (sizeCard.includes(selectedOptions[0]) && pack == inputValue)
        ) {
          return false;
        }
      } else if (optionLevel == 2) {
        if (
          styles.includes(selectedOptions[0]) &&
          !colorFilter.includes(selectedOptions[1]) &&
          sizeFilter.includes(inputValue)
        ) {
          return false;
        }
      }
    }

    return true;
  }
  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (event) {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      this.dispatchProductSelectEvent();

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptions: this.getAllSelectedOptions(),
        },
      });
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.rejectPendingSelectPromise(new Error('VARIANT_UNAVAILABLE'));
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    const campShirt = document.querySelector(
      '#product_type[data-type="Shirt"]',
    );
    if (campShirt && showDateCutOff) {
      const codeCountry = getCookieByProduct('code_country') || 'US';
      loadDateCutOff(codeCountry);
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

   updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
   // var formatCurrency = $('body').data('money-format');

    if (this.currentVariant && this.currentVariant.available) {
      /*const money = Shopify.formatMoney(
        this.currentVariant.price,
        formatCurrency
      );*/
      return;
    }

    if (!this.currentVariant && this.options.length == 3 || this.currentVariant && this.currentVariant.available == false) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return (
          variant.options[0] === this.options[0] &&
          variant.options[1] === this.options[1]
        );
      });

      if (!this.currentVariant || this.currentVariant && this.currentVariant.available == false) {
        this.currentVariant = this.getVariantData().find((variant) => {
          return variant.options[0] === this.options[0] && variant.available;
        });
      }

      if (this.currentVariant && this.currentVariant.available) {
        const option2 = document.querySelector(
          `input[value='${this.currentVariant.option2}']`,
        );
        if (option2) option2.checked = true;
      }
    }

    if (!this.currentVariant || this.currentVariant && this.currentVariant.available == false) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.options[0] === this.options[0];
      });
    }

    if (this.options.length == 3) {
      if (this.currentVariant) {
        document.querySelector(
          `input[value='${this.currentVariant.option3}']`,
        ).checked = true;
      }
    }

    if (this.options.length == 2) {
      document.querySelector(
        `input[value="${this.currentVariant.option1}"]`,
      ).checked = true;

      document.querySelector(
        `input[value='${this.currentVariant.option2}']`,
      ).checked = true;
    }

    /*const money = Shopify.formatMoney(
      this.currentVariant.price,
      formatCurrency
    );*/

    this.options = this.updateOptions();
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery.setActiveMedia) {
        return mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          true,
        );
      }
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      pickUpAvailability.fetchAvailability
    ) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && productForm.handleErrorMessage)
      productForm.handleErrorMessage();
  }
  customPriceByUTM(cents, discount, isOrnament = false, items = 5) {
    const discounted = applyDisplayDiscount(cents,discount);
    const priceLarge = document.querySelector(".price.price--large");
    if (priceLarge) priceLarge.insertAdjacentHTML("beforeend", getPriceDiscountProduct(discounted, items, isOrnament));

    const saleItem = document.querySelector(".price__sale .box-price-final .price-item.price-item--sale.price-item--last.money");
    if (saleItem) saleItem.classList.add("color-custom");

    const saleBadge = document.querySelector(".price__sale .box-price-final .badge.price__badge-sale.color-accent-2");
    if (saleBadge) saleBadge.classList.add("hidden");
  }
  renderProductInfo() {
    const that = this;
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const variantSelects = html.querySelector('variant-selects');
        if(variantSelects){
          const variantSelectOld = document.querySelector('variant-selects');
          variantSelectOld.innerHTML = variantSelects.innerHTML
        }
        const priceOFF = html.querySelector('.sale-banner__title');
        const priceOFFChange = document.querySelector('.sale-banner__title');
        if(priceOFF && priceOFFChange){
          priceOFFChange.innerHTML = priceOFF.innerHTML
        }
        const variantBundles = html.getElementById('variant-bundles');
        const variantTeddyBear = html.getElementById('variant-teddyBear');
        const mutiplateBox = html.getElementById('mutiplate-size-box');
        // update UI Pack 
        const mutiplatePack = html.getElementById('mutiplate-pack-options');
        if(mutiplatePack){
          const mutiplatePackOld = document.querySelector('variant-radios.no-js-hidden');
          const mutiplatePackNew = html.querySelector('variant-radios.no-js-hidden');
          if(mutiplatePackOld && mutiplatePackNew){
            mutiplatePackOld.innerHTML = mutiplatePackNew.innerHTML
          }
        }
        if (variantBundles || variantTeddyBear || mutiplateBox) {
          const formGiftBox = document.getElementById('form-gift-box');
          const giftBox = document.querySelector('.gift-box.box');
          if (formGiftBox && giftBox) {
            formGiftBox.innerHTML =
              html.getElementById('form-gift-box')?.innerHTML;
            giftBox.innerHTML = html.querySelector('.gift-box.box')?.innerHTML;
          }

          // updateGiftBoxUI();
        }

        // default qty box buy pack
          const pack = html.querySelector('.qty_default_box');
          const qty_box = document.querySelector('[name="quantity-box"]')

          if(pack && pack.innerText && qty_box){
            qty_box.value = parseInt(pack.innerText)
          }
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`,
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`,
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`,
        );

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination)
          volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;

        const priceDiscount = destination.querySelector(".price__regular .price-item.price-item--regular.money");
        const params = new URLSearchParams(window.location.search);
        // check UTM campaign for Meta Ads
        const utm = params.get('utm_discount');
        const utmValue = getCookieByProduct('utm_discount');
        const regex = /BF(\d+)FB|FB(\d+)/;
        let discount = utm?.match(regex)?.[1] || utm?.match(regex)?.[2] || utmValue?.match(regex)?.[1] || utmValue?.match(regex)?.[2];
        
        // new flow discount UTM 
        const productCollection = document.querySelector(".collection-meta")?.textContent;
        let ITEM_DISCOUNT = discountUTM?.find(item=> item.code == utmValue);
        const productType = document.querySelector(".product-type");
        const productID = document.querySelector(".product-id");
        const COUNTRY_CODE = document.body.getAttribute('country-code');
        const collectionDish = document.querySelector(".collection-meta-dish");
        if (!isDiscountAllowedForCountry(ITEM_DISCOUNT, COUNTRY_CODE)) {
          ITEM_DISCOUNT = null;
        }

        if(discountUTM && ITEM_DISCOUNT){

          if(ITEM_DISCOUNT.ads == 'meta' && priceDiscount && ITEM_DISCOUNT.collection?.includes(productCollection) || ITEM_DISCOUNT.ads == 'meta' && priceDiscount && ITEM_DISCOUNT.collection == null){
              discount = ITEM_DISCOUNT.discount;
              const raw = priceDiscount.getAttribute('data-price');
              const cents = raw ? parseInt(raw, 10) : null;
              if (cents){
                if(ITEM_DISCOUNT.items && ITEM_DISCOUNT.price){
                  that.customPriceByUTM(cents, discount, true, ITEM_DISCOUNT.items);
                }else{
                  that.customPriceByUTM(cents, discount);
                }
                
                updatePricePack(discount)
              }
          }else if(ITEM_DISCOUNT.ads == 'google' && priceDiscount && ITEM_DISCOUNT.type?.includes(productType?.innerText) || ITEM_DISCOUNT.ads == 'google' && priceDiscount && ITEM_DISCOUNT.type == null && isDiscountAllowedForCountry(ITEM_DISCOUNT, COUNTRY_CODE)){              
              const raw = priceDiscount && priceDiscount.getAttribute('data-price');
              const cents = raw ? parseInt(raw, 10) : null;
              discount = ITEM_DISCOUNT.discount;
              if (cents && discount){
                that.customPriceByUTM(cents, discount);
                updatePricePack(discount)
              }
            
          }else {
             if(collectionDish && collectionDish.innerText == 'Jewelry Dish'){
              const raw = priceDiscount && priceDiscount.getAttribute('data-price');
              const cents = raw ? parseInt(raw, 10) : null;
              const discountBFCM = 20;
              if (cents){
                that.customPriceByUTM(cents, discountBFCM);
                updatePricePack(discountBFCM)
              }
            }
            
          } 
        }

        if(!ITEM_DISCOUNT && discount){
            const raw = priceDiscount && priceDiscount.getAttribute('data-price');
            const cents = raw ? parseInt(raw, 10) : null;
            if (cents){
              that.customPriceByUTM(cents, discount);
              updatePricePack(discount, false)
            }
        }
        // if(!utmValue && priceDiscount){
        //     const raw = priceDiscount && priceDiscount.getAttribute('data-price');
        //     const cents = raw ? parseInt(raw, 10) : null;
        //     const discountBFCM = 10
        //     if (cents){
        //       that.customPriceByUTM(cents, discountBFCM, false, 2);
        //       updatePricePack(discountBFCM, false)
        //     }
        // }


          
        // }
        // End new flow discount UTM
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'hidden',
            skuSource.classList.contains('hidden'),
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            'hidden',
            pricePerItemSource.classList.contains('hidden'),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'hidden',
            inventorySource.innerText === '',
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );
        // const currency = getCookieByProduct("currency");
        // if (Currency && currency) {
        //   Currency.convertAll(
        //     "USD",
        //     currency,
        //     ".money",
        //     "money_with_currency_format"
        //   );
        // }
        if (this.currentVariant) {
          const sourceVariantSelects = html.querySelector('variant-selects, variant-radios');
          this.resolvePendingSelectPromise(this.currentVariant, sourceVariantSelects);
        } else {
          this.resolvePendingSelectPromise(null);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getAllSelectedOptions() {
    const options = [];
    this.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
      const checked = group.querySelector('input:checked') || group.querySelector('select option[selected]');
      if (checked) {
        options.push({ name: checked.dataset.optionName || '', value: checked.value });
      }
    });
    return options;
  }

  dispatchProductSelectEvent() {
    const { ProductSelectEvent } = window.StandardEvents || {};
    if (!ProductSelectEvent) return;

    const deferred = ProductSelectEvent.createPromise();
    this.pendingSelectPromise = deferred;

    this.dispatchEvent(
      new ProductSelectEvent({
        product: {
          id: this.dataset.productId,
          title: this.dataset.productTitle,
          handle: this.dataset.productHandle,
        },
        selectedOptions: this.getAllSelectedOptions(),
        promise: deferred.promise,
      })
    );
  }

  takePendingSelectPromise() {
    const deferred = this.pendingSelectPromise;
    this.pendingSelectPromise = null;
    return deferred;
  }

  resolvePendingSelectPromise(variant, sourceVariantSelects = this) {
    const deferred = this.takePendingSelectPromise();
    if (!deferred) return;

    if (variant) {
      deferred.resolve({
        variant: {
          id: variant.id,
          title: variant.title,
          availableForSale: variant.available,
          price: {
            amount: sourceVariantSelects?.dataset.selectedPriceAmount,
            currencyCode: sourceVariantSelects?.dataset.currencyCode,
          },
          selectedOptions: this.getAllSelectedOptions(),
        },
      });
    } else {
      deferred.resolve({ variant: null });
    }
  }

  rejectPendingSelectPromise(error) {
    this.takePendingSelectPromise()?.reject(error);
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        ?.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('#box-shipping, .deliver-to-country-line .deliver-to-country, .selected-coutry').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      // Close mobile drawer if open
      var drawer = document.querySelector('.macorner-drawer');
      var backdrop = document.querySelector('.macorner-drawer__backdrop');
      if (drawer) drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';

      const modal = document.querySelector('#box-shipping-country');
      if (modal) modal.show(el);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var currency = document.querySelector('.currencies')?.value;
  var desktop = document.getElementById('pp-pay-later-message-desktop');
  var mobile = document.getElementById('pp-pay-later-message');

  if (currency === 'USD') {
    if (desktop) desktop.style.display = '';
    if (mobile) mobile.style.display = '';
  } else {
    if (desktop) desktop.style.display = 'none';
    if (mobile) mobile.style.display = 'none';
  }
});

document.body.addEventListener('change', function (e) {
  if (!e.target.matches('.currencies')) return;
  var currency = e.target.value;
  var desktop = document.getElementById('pp-pay-later-message-desktop');
  var mobile = document.getElementById('pp-pay-later-message');

  if (currency === 'USD') {
    if (desktop) desktop.style.display = '';
    if (mobile) mobile.style.display = '';
  } else {
    if (desktop) desktop.style.display = 'none';
    if (mobile) mobile.style.display = 'none';
  }
});
function generateFileAuth(apiKey) {
  if (!engraver) {
    alert('not support');
    return;
  }
  if (!engraver.currentProduct) {
    alert('no select currentProduct');
    return;
  }
  var texts = engraver.textObjects.map(function (t) {
      return {
        id: t.id,
        uuid: t.uuid,
        textValue: t.clText || t.getText(),
        colorOption: t.selectedColorId || 1,
        colorHex: t.selectedColorHex,
        fontId: t.selectedFont || 1,
      };
    }),
    circularsText = engraver.circularTextObjects.map(function (t) {
      return {
        id: t.id,
        uuid: t.uuid,
        textValue: t.clText || t.text,
        colorOption: t.selectedColorId || 1,
        colorHex: t.selectedColorHex,
        fontId: t.selectedFont || 1,
      };
    });
  var vectorObjects = engraver.vectorEPSObjects
      .filter(function (t) {
        return !t.allowUserUpload;
      })
      .map(function (t) {
        return {
          id: t.id,
          uuid: t.uuid,
          position: t.selectedVectorIndex,
          realPosition:
            t.vectorLibraryId || t.hasLibrary
              ? t.selectedVectorIndex
              : t.selectedVectorIndex + 1,
          colorPosition: t.lastColorPosition,
          colorHex: t.lastColorHex,
        };
      }),
    imagesParameters = engraver.imageHolderObjects.map(function (t) {
      var e = '';
      return (
        (e =
          t.hasStaticImage || t.dynamicImagesPath
            ? t.id + '-serverStoredImage'
            : t.imageName),
        {
          id: t.id,
          isStaticImage: !!t.hasStaticImage,
          fileName: e,
          uuid: t.uuid,
          position: t.selectedImageIndex,
          colorPosition: t.lastColorPosition,
          colorHex: t.lastColorHex,
          offsetX: t.getEditModeImageParameters().offsetX,
          offsetY: t.getEditModeImageParameters().offsetY,
          previewOriginalElementWidth: t.originalElement.width,
          previewOriginalElementHeight: t.originalElement.height,
          angle: t.getEditModeImageParameters().angle,
          maskScaleX: t.getEditModeImageParameters().scaleX,
          maskScaleY: t.getEditModeImageParameters().scaleY,
          threshold: t.threshold,
        }
      );
    }),
    vectorsParameters = engraver.vectorEPSObjects
      .filter(function (t) {
        return t.allowUserUpload;
      })
      .map(function (t) {
        var e = t.getEditModeParameters();
        return {
          id: t.id,
          fileName: t.vectorName,
          uuid: t.uuid,
          offsetX: e.offsetX,
          offsetY: e.offsetY,
          scaleX: e.scaleX,
          scaleY: e.scaleY,
          angle: e.angle,
        };
      });

  var payload = {
    texts: texts,
    circularTexts: circularsText,
    vectorPlaceholders: vectorObjects,
    id: engraver.currentProduct.id,
    fileName: 'sadasdas-.png',
    sessionId: engraver.getSessionId(),
    clientVersion: '1.0.0',
    imagesParameters: imagesParameters,
    vectorsParameters: vectorsParameters,
  };

  return $.ajax({
    type: 'POST',
    url: 'https://design-prod.medzt.com/api/productfile/generate-auth',
    crossDomain: !0,
    data: payload,
    dataType: 'json',
    headers: { authorization: apiKey },
    error: function (request, status, error) {
      const responseEror = JSON.parse(request.responseText);
      if (responseEror && responseEror.message) {
        alert(responseEror.message);
      }
    },
  });
}

/*$(document).keydown(function (event) {
  if (window.matchMedia("(max-width: 700px)").matches) {
    return;
  }
  if (event.keyCode == 123) {
    // Prevent F12
    return false;
  } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
    // Prevent Ctrl+Shift+I
    return false;
  }
});

$(document).on("contextmenu", function (e) {
  if (window.matchMedia("(max-width: 700px)").matches) {
    return;
  }
  e.preventDefault();
});*/
function actionTabs(className) {
  const divElement = document.querySelector(`.${className}`);
  if (!divElement) return;

  let curTab = 0;

  const sixteenColumns = divElement.querySelector('.sixteen.columns');
  const boxActionTab = sixteenColumns.querySelector('.box-action-tabs');
  const collectionTab = boxActionTab.querySelector('.tab-collection');

  if (collectionTab.scrollWidth >= boxActionTab.clientWidth) {
    collectionTab.classList.toggle('flex');
    boxActionTab.querySelector('.pf_arrow-next')?.classList.toggle('show-action');
  }

  const tabMenu = divElement.querySelectorAll(
    '.collection-banner .collection-tab-sub-content .box-action-tabs .tab-collection .tab-collection-title'
  );

  const tabBar = boxActionTab.querySelector('.tab-collection');
  const tabBarCon = sixteenColumns;

  let maxTabOffset = tabBarCon.clientWidth;

  boxActionTab.querySelector('.pf_arrow-next')?.addEventListener('click', () => {
    if (curTab < tabMenu.length - 1) {
      autoScroll(1);
      tabMenu[++curTab].click();
    }
  });

  boxActionTab.querySelector('.pf_arrow-prev')?.addEventListener('click', () => {
    if (curTab > 0) {
      autoScroll(0);
      tabMenu[--curTab].click();
    }
  });

  if (tabBar.scrollWidth > boxActionTab.clientWidth) {
    tabBar.classList.add('active');
  } else {
    tabBar.classList.remove('active');
  }

  function autoScroll(direction) {
    if (direction > 0) {
      const nextTab = tabMenu[curTab + 1];
      const posTab = nextTab.offsetLeft + nextTab.clientWidth;

      if (posTab >= maxTabOffset) {
        tabBar.scrollTo({
          left: nextTab.offsetLeft - tabBar.clientWidth * 0.03,
          behavior: 'smooth',
        });

        boxActionTab.querySelector('.pf_arrow-prev')?.classList.add('show-action');
      }
      if (posTab < maxTabOffset) {
        boxActionTab.querySelector('.pf_arrow-prev')?.classList.remove('show-action');
      }

      if (curTab + 1 === tabMenu.length - 1) {
        boxActionTab.querySelector('.pf_arrow-next')?.classList.remove('show-action');
      }
    } else {
      const prevTab = tabMenu[curTab - 1];

      if (prevTab.offsetLeft === 0) {
        boxActionTab.querySelector('.pf_arrow-prev')?.classList.remove('show-action');
      }

      tabBar.scrollTo({
        left: prevTab.offsetLeft - tabBar.clientWidth * 0.03,
        behavior: 'smooth',
      });

      boxActionTab.querySelector('.pf_arrow-next')?.classList.add('show-action');
    }
  }

  tabMenu.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      tabMenu.forEach(item => item.classList.remove('active'));
      this.classList.add('active');
      const slugCollection = this.getAttribute('slug-col');
      const parentCollection = this.closest('.sixteen.columns');
      curTab = index;

      parentCollection.querySelectorAll('.featured-collection-product').forEach(el => el.classList.remove('active'));
      parentCollection.querySelector(`.featured-collection-product[slug-col="${slugCollection}"]`)?.classList.add('active');
      parentCollection.querySelectorAll('.collection-shop-all').forEach(el => el.classList.remove('active'));
      parentCollection.querySelector(`.collection-shop-all[slug-col="${slugCollection}"]`)?.classList.add('active');
    });
  });
}
function getCookieByProduct(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}
const addMaximumScaleToMetaViewport = () => {
  const el = document.querySelector('meta[name=viewport]');

  if (el !== null) {
    let content = el.getAttribute('content');
    let re = /maximum\-scale=[0-9\.]+/g;

    if (re.test(content)) {
      content = content.replace(re, 'maximum-scale=1.0');
    } else {
      content = [content, 'maximum-scale=1.0'].join(', ');
    }

    el.setAttribute('content', content);
  }
};

const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
const checkIsIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (checkIsIOS()) {
  disableIosTextFieldZoom();
}

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    const btn = document.getElementById('customily-cart-btn-preview');
    if (btn) btn.classList.remove('ld-custom');
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   // Fetch cart data on initial page load
//   fetchCartData();

//   // Fetch cart data after AJAX page navigation (if applicable)
//   document.addEventListener('pageshow', function () {
//     fetchCartData();
//   });

  function fetchCartData() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        const cartCount = document.getElementById('header-cart-count-bubble');
        // if (cartCount[0]) {
        //   cartCount[0].innerHTML = data.item_count;
        // }
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }
      });
  }

const trendingImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="increase 1"> <path id="Vector" d="M15.4516 3.85514L15.1547 6.71657C15.1204 7.03068 14.7351 7.16565 14.5142 6.94479L13.8124 6.24292L9.3926 10.6627C9.11529 10.94 8.62694 10.94 8.34963 10.6627L5.91522 8.22825L1.80224 12.3437C1.6599 12.486 1.47095 12.5597 1.28198 12.5597C1.09302 12.5597 0.904065 12.486 0.761726 12.3437C0.474607 12.0566 0.474607 11.5903 0.761726 11.3007L5.39497 6.66748C5.67227 6.39018 6.16063 6.39018 6.43548 6.66748L8.87235 9.10189L12.7718 5.20241L11.9497 4.38031C11.7264 4.15699 11.8614 3.77171 12.1755 3.73981L15.0369 3.44286C15.275 3.41587 15.4762 3.61711 15.4516 3.85514Z" fill="#8E8E93"/></g></svg>
  `;
const recentImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="clock-circular-outline 1"> <path id="Vector" d="M8 1C4.14014 1 1 4.14014 1 8C1 11.8599 4.14014 15 8 15C11.8599 15 15 11.8599 15 8C15 4.14014 11.8599 1 8 1ZM8 13.4699C4.98379 13.4699 2.53005 11.0162 2.53005 8C2.53005 4.98394 4.98379 2.53005 8 2.53005C11.0162 2.53005 13.4699 4.98394 13.4699 8C13.4699 11.0162 11.0162 13.4699 8 13.4699Z" fill="#8E8E93"/> <path id="Vector_2" d="M8.60589 8.00841V5.07455C8.60589 4.74697 8.34043 4.48151 8.01297 4.48151C7.68541 4.48151 7.41992 4.74697 7.41992 5.07455V8.19786C7.41992 8.20719 7.42222 8.21594 7.42267 8.22527C7.41487 8.38652 7.47042 8.55025 7.59358 8.67343L9.80223 10.8819C10.0339 11.1136 10.4094 11.1136 10.6408 10.8819C10.8723 10.6503 10.8725 10.2748 10.6408 10.0433L8.60589 8.00841Z" fill="#8E8E93"/></g></svg>
  `;
const searchImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="Search"> <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M3.29816 7.21906C3.29816 4.69387 5.34523 2.64679 7.87043 2.64679C10.3956 2.64679 12.4427 4.69387 12.4427 7.21906C12.4427 9.74426 10.3956 11.7913 7.87043 11.7913C5.34523 11.7913 3.29816 9.74426 3.29816 7.21906ZM7.87043 1C4.43574 1 1.65137 3.78437 1.65137 7.21906C1.65137 10.6538 4.43574 13.4381 7.87043 13.4381C9.21931 13.4381 10.4679 13.0087 11.4869 12.2791L13.157 13.9449C13.479 14.266 14.0004 14.2654 14.3215 13.9434C14.6426 13.6214 14.642 13.1001 14.32 12.7789L12.6885 11.1517C13.5642 10.0801 14.0895 8.71091 14.0895 7.21906C14.0895 3.78437 11.3051 1 7.87043 1Z" fill="#8E8E93"/></g></svg>
  `;
let maxRetries = 5;
function getPopularSearch() {
  let popularSearch = window.Searchanise?.preloadedSuggestions;

  if (!popularSearch?.length) {
    popularSearch = localStorage.getItem('popularSearch')
      ? JSON.parse(localStorage.getItem('popularSearch'))
      : '';
    return popularSearch;
  }
  localStorage.setItem(
    'popularSearch',
    JSON.stringify(popularSearch.slice(0, 5)),
  );
  return popularSearch.slice(0, 5);
}
function getRecentSearch() {
  try {
    const recentSearches = localStorage.getItem('search-recent')
      ? JSON.parse(localStorage.getItem('search-recent'))
      : '';
    return Array.isArray(recentSearches)
      ? recentSearches.filter((v) => v && v.trim())
      : [];
  } catch (e) {
    return [];
  }
}
function renderInitialSearch() {
  const popularSearches = getPopularSearch();
  const recentSearches = getRecentSearch();
  let content = `
    ${
      popularSearches?.length
        ? ` <p class="title">Trending Searches</p> <div class='popular-search-wrapper'>
            ${popularSearches
              .map(
                (item) =>
                  `<li><a href="/pages/search-results-page/?q=${encodeURIComponent(
                    item,
                  )}" class="popular-search-item">
                ${trendingImg}
                ${item}</a></li>`,
              )
              .join(' ')}</div>
        `
        : ''
    }
    ${
      recentSearches?.length
        ? ` <p class="title">Recent Searches</p> <div class='recent-search-wrapper'>
            ${recentSearches
              .map(
                (item) =>
                  `<li><a href="/pages/search-results-page/?q=${encodeURIComponent(
                    item,
                  )}" class="recent-search-item">
                ${recentImg}
                <span>${item}</span></a></li>`,
              )
              .join(' ')}</div>
        `
        : ''
    }
  `;
  // $('.app_results_container, .app_results_container-mb').html(content);
  document.querySelectorAll('.app_results_container, .app_results_container-mb').forEach((el) => {el.innerHTML = content;});
  setTimeout(() => {
    const popularSearch = window.Searchanise?.preloadedSuggestions;

    if (popularSearch?.length) {
      localStorage.setItem(
        'popularSearch',
        JSON.stringify(popularSearch.slice(0, 5)),
      );
    }
  }, 1000);
}
function getPersonalizationSearch() {
  const defaultData = {
    recentlyViewedProducts: [],
    recentlyAddedToCartProducts: [],
    recentlyPurchasedProducts: [],
  };
  try {
    const personalization = localStorage.getItem('Personalization');
    return personalization ? JSON.parse(personalization) : defaultData;
  } catch (err) {
    return defaultData;
  }
}
const debounceSearch = (fn, delay = 1000) => {
  let timerId = null;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => fn(...args), delay);
  };
};
const onInputSearch = debounceSearch(handleSearch, 500);
function getSearchResultsFromPreload(searchTemp) {
  const popularSearch = window.Searchanise?.preloadedSuggestions;
  if (!popularSearch?.length) {
    return [];
  }
  return popularSearch
    .filter((p) => p.includes(searchTemp))
    .slice(0, limitSearchResult)
    .map((value) => {
      if (value.split(' ').length > 10) {
        let splitString = value.split(searchTemp);
        if (splitString.length > 1) splitString.shift();
        return splitString.length > 0
          ? `${searchTemp}${splitString[0]}`
          : value;
      }
      return value;
    });
}
function renderResultSearch(res, searchText, items = []) {
  if (!res || !Array.isArray(res.suggestions)) return;
  const search = searchText.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(search, 'gi');

  // Render Suggestions
  const suggestionsHtml = res.suggestions
    .map((item) => {
      const highlightedText = item.replace(re, `<mark>$&</mark>`);
      return `
        <a href="/pages/search-results-page/?q=${encodeURIComponent(
          item,
        )}" 
           class="suggestion-search-item" 
           title="${item}">
          ${searchImg} <span>${highlightedText}</span>
        </a>`;
    })
    .join('');

  // Render  Products
  const productsHtml = items?.length
    ? items
        .map(
          (item) => `
          <a href="${item.link}">
            <img src="${item?.image_link}" alt="${item.title}" />
            <p>${item.title}</p>
          </a>`,
        )
        .join('')
    : '';

  const content = `
    <div class="suggestion-search-wrapper">
      <div class="suggestions">Suggestions</div>
      ${suggestionsHtml}
      <div class="suggestions ${
        items?.length === 0 ? 'hidden' : 'show'
      }">Products</div>
      ${productsHtml}
    </div>`;

  const container = document.querySelector(".app_results_container-mb");
  if (!container) return;
  container.innerHTML = content;

  container.querySelectorAll(".suggestion-search-item").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      const href = this.getAttribute("href");
      const formValue = this.getAttribute("title");
      const listRecentSearch = getRecentSearch();

      if (!listRecentSearch.includes(formValue)) {
        listRecentSearch.unshift(formValue);
        localStorage.setItem(
          "search-recent",
          JSON.stringify(listRecentSearch.slice(0, 3))
        );
      }
      window.location.href = href;
    });
  });
}

function renderNotFound(searchText) {
  let content = ` <div class="not-found-wrapper"> <p class="title">Sorry, nothing found for <span>${searchText}</span>.</p> </div>
  `;
  $('.app_results_container-mb').html(content);
}
function renderProducts(res) {
  const productsHtml = res?.items?.length
    ? res?.items
        .map(
          (item) => `
        <a href="${item.link}">
          <img src="${item?.image_link}" alt="${item.title}" />
          <p>${item.title}</p>
        </a>`,
        )
        .join('')
    : '';

  const content = `
    <div class="suggestion-search-wrapper">
      <div class="suggestions ${
        res?.items?.length === 0 ? 'hidden' : 'show'
      }">Products</div>
      ${productsHtml}
    </div>`;

  $('.app_results_container-mb').html(content);
}
async function handleSearch(inputElement) {
  try {
    const baseUrl = 'https://www.searchanise.com/getwidgets';
    const apiKey = '4M1G0o2c6c';

    const personalizationSearchData = getPersonalizationSearch();
    // let currentTextSearch = inputElement.val();
    let currentTextSearch = inputElement.value;
    if (!currentTextSearch) {
      renderInitialSearch();
      return;
    }
    const preloadSearch = getSearchResultsFromPreload(currentTextSearch);
    const lengthPreloadSearch = preloadSearch.length;
    if (lengthPreloadSearch > 0) {
      renderResultSearch({ suggestions: preloadSearch }, currentTextSearch);
    }
    const myParams = {
      api_key: apiKey,
      q: currentTextSearch,
      maxResults: 3,
      startIndex: 0,
      items: true,
      pages: false,
      facets: false,
      categories: false,
      suggestions: true,
      vendors: false,
      tags: false,
      pageStartIndex: 0,
      pagesMaxResults: 0,
      categoryStartIndex: 0,
      categoriesMaxResults: 0,
      suggestionsMaxResults: limitSearchResult,
      vendorsMaxResults: 0,
      tagsMaxResults: 0,
      ...personalizationSearchData,
    };
    const queryString = new URLSearchParams(myParams).toString();
    const rawResponse = await fetch(`${baseUrl}?${queryString}`);
    const res = await rawResponse.json();
    // currentTextSearch = inputElement.val();
    currentTextSearch = inputElement.value;
    if (!currentTextSearch) {
      renderInitialSearch();
      return;
    }

    if (!res?.suggestions?.length) {
      if (res?.items?.length > 0) {
        renderProducts(res);
      } else if (!lengthPreloadSearch) {
        renderNotFound(currentTextSearch);
      }
    } else {
      if (lengthPreloadSearch < limitSearchResult) {
        const suggestionsRender = [
          ...new Set([...res.suggestions, ...preloadSearch]),
        ].slice(0, limitSearchResult);
        renderResultSearch(
          { suggestions: suggestionsRender },
          currentTextSearch,
          res?.items,
        );
      }
    }
  } catch (e) {
    console.log('error', e);
  }
}

//footer
const limitSearchResult = 10;
document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.footer__content-top .footer-block__details-content a.sub-link')
    .forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        this.classList.toggle('active');
      });
    });

  document
    .querySelectorAll(".header__search input[type='search']")
    .forEach(function (input) {
      input.addEventListener('click', function () {
        const parent = this.closest('.search_container');

        if (!this.value && parent) {
          parent.querySelector('.search_results_overlay')?.style.setProperty('display', 'block');
          parent.querySelector('.app_results_container')?.style.setProperty('display', 'block');
        }

        renderInitialSearch();
      });
    });

  document
    .querySelectorAll('.search-modal__close-button')
    .forEach(function (btn) {
      btn.addEventListener('click', function () {
        document
          .querySelectorAll(
            '.search_results_overlay-mb,.app_results_container-mb,.closed-modal-search',
          )
          .forEach((el) => (el.style.display = ''));

        document.querySelector('.search-modal')?.classList.add('show');

        renderInitialSearch();

        const input = document.querySelector('.search_form_mb input');
        input?.focus();

        if (input?.value) {
          onInputSearch(input);
        }
      });
    });

  document
    .querySelectorAll('.macorner-header__search .search_form_mb, .header__search .search_form_mb, .search.hidden-xs')
    .forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const input = this.querySelector('input');
        const formValue = input ? input.value : '';

        if (formValue && formValue.trim()) {
          const listRecentSearch = getRecentSearch();

          if (!listRecentSearch.includes(formValue)) {
            listRecentSearch.unshift(formValue);

            localStorage.setItem(
              'search-recent',
              JSON.stringify(listRecentSearch.slice(0, 3)),
            );
          }
        }

        window.location.href =
          '/pages/search-results-page/?q=' +
          encodeURIComponent(formValue);
      });
    });

  document.body.addEventListener('input', function (e) {
    if (
      e.target.matches(
        '.header__search.search_container .search__input.field__input, .header__search.search_container .macorner-header__search-input',
      )
    ) {
      const value = e.target.value;

      document
        .querySelectorAll('.search_results_overlay')
        .forEach((el) => (el.style.display = value ? 'none' : 'block'));

      document
        .querySelectorAll('.app_results_container,.closed-modal-search')
        .forEach((el) => (el.style.display = value ? 'none' : 'block'));

      if (
        !value &&
        !document.querySelector(
          '.app_results_container .popular-search-item',
        )
      ) {
        renderInitialSearch();
      }
    }

    if (e.target.matches('.search_form_mb input[type="text"]')) {
      onInputSearch(e.target);
    }
  });

  document
    .querySelectorAll('.search_form_mb input[type="text"]')
    .forEach(function (input) {
      input.addEventListener('paste', function () {
        onInputSearch(this);
      });
    });

  document
    .querySelectorAll('.search_results_overlay-mb,.closed-modal-search')
    .forEach(function (el) {
      el.addEventListener('click', function () {
        document
          .querySelectorAll(
            '.search_results_overlay-mb,.app_results_container-mb,.closed-modal-search',
          )
          .forEach((item) => (item.style.display = 'none'));

        document.querySelector('.search-modal')?.classList.remove('show');
      });
    });

  const target = document.querySelector('.grid__item.product__media-wrapper');
  const btnPreview = document.querySelector('.btn-preview-wrapper') || document.querySelector('.btn-preview');

  if (target && btnPreview && window.innerWidth <= 1024) {
    const previewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            // Target scrolled past viewport → show button
            const belowViewport = entry.boundingClientRect.top < 0;
            if (belowViewport || entry.boundingClientRect.bottom < window.innerHeight - 150) {
              btnPreview.style.display = '';
              btnPreview.classList.remove('hidden-btn-preview');
            }
          } else {
            btnPreview.style.display = 'none';
            btnPreview.classList.add('hidden-btn-preview');
          }
        });
      },
      { rootMargin: '-150px 0px 0px 0px' },
    );
    previewObserver.observe(target);
  }

  //focus searh mobile 
  const search = document.querySelector('.macorner-search-mobile');
  const input = search?.querySelector('input');
  const results = document.querySelector('.app_results_container-mb');

  if (input && results && search) {
    input.addEventListener('focus', () => {
      results.style.display = 'block';
    });

    document.addEventListener('click', (e) => {
      if (!search.contains(e.target)) {
        results.style.display = 'none';
      }
    });
  }
});

document.addEventListener('click', function (e) {
  if (!e.target.closest('.header__search.search_container')) {
    document
      .querySelectorAll('.search_results_overlay, .app_results_container, .closed-modal-search')
      .forEach((el) => {
        el.style.display = 'none';
      });
  }

  const moreDetail = e.target.closest('.more-detail-gift-box');
  if (moreDetail) {
    moreDetail.parentElement?.querySelector('img')?.click();
    return;
  }

  const giftImg = e.target.closest('.gift-box-content-img img');
  if (giftImg) {
    giftImg.parentElement.classList.toggle('modal');
    document.querySelector('.modal-box')?.classList.toggle('hidden');
    document.body.classList.toggle('none-scroll');
    return;
  }

  if (e.target.closest('.cloded-gift-box, .modal-box')) {
    document.querySelectorAll('.gift-box-content-img').forEach((el) => el.classList.remove('modal'));
    document.querySelector('.modal-box')?.classList.add('hidden');
    document.body.classList.remove('none-scroll');
  }
});

// convert size inches to cm size chart
var btnConvertSizeCM = document.querySelectorAll('.btn-size-chart.cm');
var btnConvertSizeIN = document.querySelectorAll('.btn-size-chart.in');

btnConvertSizeCM &&
  btnConvertSizeCM.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-active')) return;
      handleSizeChartCm();
    });
  });
function getListSize(element) {
  const listSize = element.textContent.split('-');
  const size1 = parseFloat(listSize[0].replace('in', '').replace('cm', ''));
  const size2 = parseFloat(listSize[1].replace('in', '').replace('cm', ''));
  const oldValue = `${size1} - ${size2}`;
  return oldValue;
}
// List of separators to check for multiple sizes chart
const separatorsList = ['–', ' x '];
function handleSizeChartCm() {
  btnConvertSizeCM.forEach(function (btn) {
    btn.classList.add('is-active');
  });

  const convertToCm = (element) => {
    let oldValue = element.getAttribute('old-value');

    const isManySize = separatorsList.some(sep => element.textContent.includes(sep));

    if (!oldValue) {
      if (isManySize) {
        element.setAttribute('old-value', element.textContent);
      } else {
        oldValue = parseFloat(element.textContent.replace('in', '').replace('cm', ''));
        element.setAttribute('old-value', oldValue);
      }

    }

    if (isManySize) {
      const textContent = element.textContent;

      const separatorselected = separatorsList.find(sep => textContent.includes(sep));
      const firstSize = separatorselected ? parseFloat(textContent.split(separatorselected)[0].trim()) : parseFloat(textContent.trim());

      const secoundSize = separatorselected 
      ? parseFloat(textContent.split(separatorselected)[1].replace('in', '').replace('cm', '').trim()) 
      : 0;


      element.textContent = `${(firstSize * 2.54).toFixed(2)} ${separatorselected} ${(secoundSize * 2.54).toFixed(2)} `;
    } else {
      element.textContent = `${(oldValue * 2.54).toFixed(2)}`;
    }
  };

  document
    .querySelectorAll('.wrapper-table table td,.wrapper-table table td div')
    .forEach(function (element) {
      const td = element.tagName === 'TD' ? element : element.closest('td');
      if (td) {
        const table = td.closest('table');
        if (table && table.__sizeIndex === undefined) {
          table.__sizeIndex = -1;
          table.querySelectorAll('tr').forEach(row => {
            Array.from(row.children).forEach((cell, index) => {
              if (cell.textContent.trim().toLowerCase() === 'size') {
                table.__sizeIndex = index;
              }
            });
          });
        }
        if (table && table.__sizeIndex === td.cellIndex) return;
      }

      const text = element.textContent;
      const match = text.match(/^\d+(\.\d+)?\s*in$/);
      if (match || element.getAttribute('old-value') || Number.isFinite(Number(text)) || separatorsList.some(sep => text.includes(sep))) {
         convertToCm(element);
      }
    });
  document.querySelectorAll('.data-size-chart-2').forEach(function (element) {
    let oldValue = element.getAttribute('old-value');
    if (!oldValue && element.textContent) {
      oldValue = getListSize(element);
      element.setAttribute('old-value', oldValue);
    }
    const listSize = oldValue.split('-');
    element.textContent = `${(listSize[0] * 2.54).toFixed(1)} - ${(
      listSize[1] * 2.54
    ).toFixed(1)}`;
  });

  btnConvertSizeIN.forEach(function (btn) {
    btn.classList.remove('is-active');
  });
}

btnConvertSizeIN &&
  btnConvertSizeIN.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-active')) return;
      handleSizeChartIn();
    });
  });

function handleSizeChartIn() {
  btnConvertSizeIN.forEach(function (btn) {
    btn.classList.add('is-active');
  });
  const convertToInches = (element) => {
    let oldValue = element.getAttribute('old-value');
    const isManySize = separatorsList.some(sep => element.textContent.includes(sep));

    if (!oldValue) {
      oldValue = parseFloat(element.textContent.replace(/in|cm/g, '').trim());
      element.setAttribute('old-value', oldValue);
        oldValue = (oldValue / 2.54).toFixed(2);
    }

    if (isManySize) {
      element.textContent = oldValue;
    } else {
      element.textContent = `${oldValue}`;
    }
  };

  document.querySelectorAll('.wrapper-table table td,.wrapper-table table td div').forEach((element) => {
    const td = element.tagName === 'TD' ? element : element.closest('td');
    if (td) {
      const table = td.closest('table');
      if (table && table.__sizeIndex === undefined) {
        table.__sizeIndex = -1;
        table.querySelectorAll('tr').forEach(row => {
          Array.from(row.children).forEach((cell, index) => {
            if (cell.textContent.trim().toLowerCase() === 'size') {
              table.__sizeIndex = index;
            }
          });
        });
      }
      if (table && table.__sizeIndex === td.cellIndex) return;
    }

    if(element.getAttribute('old-value')){
          convertToInches(element);
    }
  });

  document.querySelectorAll('.data-size-chart-2').forEach(function (element) {
    let oldValue = element.getAttribute('old-value');
    if (!oldValue && element.textContent) {
      oldValue = getListSize(element);
      element.setAttribute('old-value', oldValue);
      element.textContent = `${(size1 / 2.54).toFixed(1)}  - ${(
        size2 / 2.54
      ).toFixed(1)} `;
    }
    const listSize = oldValue.split('-');
    element.textContent = `${listSize[0]} - ${listSize[1]} `;
  });

  btnConvertSizeCM.forEach(function (btn) {
    btn.classList.remove('is-active');
  });
}

function setCookieUTM(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
  document.cookie = key + "=" + value + "; path=/; expires=" + expires.toUTCString();
}

// check URL show promotion and set cookie
document.addEventListener('DOMContentLoaded', function () {
    const showPromotion = getCookieByProduct('showPromotion')

    if (window.location.href.includes('promotion') || showPromotion) {
      $(document).ready(function () {
        if($('body.cart').length > 0 || $('body.index').length > 0 || $('body.page').length > 0){
          return
        }

        $('.header-wrapper').prepend(`
          <div class="promotion-box">
            <div class="page-width">🔔 Final price in cart – auto discount applied.</div>        
          </div>
        `);

        if(!showPromotion){
          setCookieUTM('showPromotion', true, 1)
        }
      });
    }
});

// check URL show discount
const regex = /BF(\d+)FB|FB(\d+)/;
function isDiscountAllowedForCountry(discountItem, countryCode) {
    if (!discountItem) return false;
    if (discountItem.scope === 'global') return true;
    if (discountItem.scope === 'country' && discountItem.countries?.includes(countryCode)) return true;
    return false;
}
function applyDisplayDiscount(cents,discountPercent = 0) {
  const discounted = Math.ceil(cents * (1 - discountPercent / 100));
  return discounted;
}

function getPriceDiscountCollections(priceDiscount) {
  return `<div class="price-discount text-price-m">
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M17.4343 2.37915C17.0003 2.45772 16.0462 2.58119 15.369 2.64105C15.0696 2.66725 13.3037 2.69344 10.7856 2.71214C8.47713 2.73085 6.47543 2.76078 6.2023 2.78323C4.76182 2.90296 3.39618 3.05636 3.35128 3.10126C3.33631 3.11248 3.44107 3.12371 3.57951 3.12371C4.66454 3.12371 8.82135 3.53902 11.0438 3.87201C13.169 4.19004 14.6618 4.30976 16.9142 4.34718L18.3846 4.36963L18.3734 3.44548L18.3622 2.51759L18.2387 2.40908C18.0928 2.27813 17.9843 2.27439 17.4343 2.37915Z" fill="#F06724"/>
        <path d="M0.945497 4.01399L0.833252 4.12624V6.00073V7.87148L0.975429 7.89393C1.48427 7.96876 1.82849 8.11468 2.13529 8.38407C2.66659 8.84801 2.92475 9.64121 2.76386 10.3222C2.57679 11.1041 1.91454 11.7252 1.12509 11.8487L0.833252 11.8973V13.5324C0.833252 14.6286 0.848218 15.1973 0.874408 15.2572C0.971687 15.4705 0.964204 15.4705 2.91727 15.4705C6.00774 15.4705 7.654 15.5977 10.0635 16.0167C11.8707 16.331 13.0193 16.4769 14.5458 16.5929C14.8339 16.6154 15.919 16.6453 16.9554 16.6565C18.6989 16.6752 18.8523 16.6715 18.9645 16.6116C19.0282 16.578 19.103 16.5069 19.1254 16.4582C19.1554 16.3946 19.1666 15.8558 19.1666 14.7297V13.0946L18.8822 13.046C17.6438 12.8514 16.8843 11.5718 17.3108 10.4045C17.5802 9.65992 18.1489 9.22216 19.0244 9.09121L19.1666 9.06876V7.19801V5.32352L19.0581 5.21501L18.9496 5.10651H17.8122C14.8452 5.10277 13.053 4.95311 10.3741 4.48916C7.70638 4.02522 6.72237 3.9429 3.50094 3.92045L1.05774 3.90175L0.945497 4.01399ZM8.25264 6.71536C8.56318 6.764 8.84754 6.90617 9.08325 7.13066C9.42747 7.45617 9.58835 7.82284 9.58835 8.28679C9.58835 8.75073 9.42747 9.1174 9.08325 9.44291C8.1591 10.3184 6.65128 9.79835 6.43427 8.53373C6.35196 8.03985 6.51659 7.53475 6.88325 7.16808C7.12271 6.93236 7.36591 6.79767 7.68019 6.73032C7.9421 6.67046 7.99074 6.67046 8.25264 6.71536ZM12.9669 7.13066C13.1091 7.20549 13.1802 7.32148 13.1802 7.50107V7.66944L10.3292 10.5242C8.58563 12.2677 7.42577 13.4052 7.3472 13.4388C7.08903 13.5511 6.81965 13.3603 6.81965 13.0647V12.9075L9.73053 10.0004C12.4094 7.31774 12.6489 7.08951 12.7611 7.08951C12.8285 7.08951 12.922 7.10821 12.9669 7.13066ZM12.3795 10.7337C13.1278 10.932 13.6441 11.6467 13.5805 12.3987C13.5244 13.0572 13.0867 13.6035 12.4506 13.8018C12.2935 13.8541 12.155 13.8654 11.9081 13.8541C11.62 13.8392 11.5414 13.8205 11.2982 13.7007C10.9577 13.5324 10.7145 13.2817 10.5499 12.9337C10.4377 12.698 10.4302 12.6569 10.4302 12.2715C10.4302 11.8786 10.4377 11.845 10.5574 11.598C10.9016 10.9021 11.6611 10.5429 12.3795 10.7337Z" fill="#F06724"/>
        <path d="M7.68023 7.56102C7.0554 7.83041 7.06288 8.75082 7.68771 9.01646C8.2003 9.22973 8.79894 8.84435 8.80268 8.29435C8.80642 7.73313 8.2003 7.33653 7.68023 7.56102Z" fill="#F06724"/>
        <path d="M11.8033 11.5045C11.5901 11.5532 11.3992 11.7103 11.2945 11.9198C11.1298 12.2528 11.1785 12.5746 11.4329 12.829C11.6948 13.0909 12.0203 13.1433 12.3533 12.9787C12.8285 12.7392 12.9333 12.1593 12.5741 11.7515C12.4656 11.6243 12.3758 11.5644 12.2336 11.5232C12.0278 11.4634 11.9867 11.4596 11.8033 11.5045Z" fill="#F06724"/>
      </svg>
      ${priceDiscount}
    </div>
    <span class="text-body-s"> (After discount)</span>
  </div>`;
}

function getPriceDiscountProduct(discounted, items, isOrnament) {
  var moneyFormat = document.body.dataset.moneyFormat;
  return `<div class="price-discount">
      <div class="box-price-discount text-price-l">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M17.4343 2.37915C17.0003 2.45772 16.0462 2.58119 15.369 2.64105C15.0696 2.66725 13.3037 2.69344 10.7856 2.71214C8.47713 2.73085 6.47543 2.76078 6.2023 2.78323C4.76182 2.90296 3.39618 3.05636 3.35128 3.10126C3.33631 3.11248 3.44107 3.12371 3.57951 3.12371C4.66454 3.12371 8.82135 3.53902 11.0438 3.87201C13.169 4.19004 14.6618 4.30976 16.9142 4.34718L18.3846 4.36963L18.3734 3.44548L18.3622 2.51759L18.2387 2.40908C18.0928 2.27813 17.9843 2.27439 17.4343 2.37915Z" fill="#F06724"/>
          <path d="M0.945497 4.01399L0.833252 4.12624V6.00073V7.87148L0.975429 7.89393C1.48427 7.96876 1.82849 8.11468 2.13529 8.38407C2.66659 8.84801 2.92475 9.64121 2.76386 10.3222C2.57679 11.1041 1.91454 11.7252 1.12509 11.8487L0.833252 11.8973V13.5324C0.833252 14.6286 0.848218 15.1973 0.874408 15.2572C0.971687 15.4705 0.964204 15.4705 2.91727 15.4705C6.00774 15.4705 7.654 15.5977 10.0635 16.0167C11.8707 16.331 13.0193 16.4769 14.5458 16.5929C14.8339 16.6154 15.919 16.6453 16.9554 16.6565C18.6989 16.6752 18.8523 16.6715 18.9645 16.6116C19.0282 16.578 19.103 16.5069 19.1254 16.4582C19.1554 16.3946 19.1666 15.8558 19.1666 14.7297V13.0946L18.8822 13.046C17.6438 12.8514 16.8843 11.5718 17.3108 10.4045C17.5802 9.65992 18.1489 9.22216 19.0244 9.09121L19.1666 9.06876V7.19801V5.32352L19.0581 5.21501L18.9496 5.10651H17.8122C14.8452 5.10277 13.053 4.95311 10.3741 4.48916C7.70638 4.02522 6.72237 3.9429 3.50094 3.92045L1.05774 3.90175L0.945497 4.01399ZM8.25264 6.71536C8.56318 6.764 8.84754 6.90617 9.08325 7.13066C9.42747 7.45617 9.58835 7.82284 9.58835 8.28679C9.58835 8.75073 9.42747 9.1174 9.08325 9.44291C8.1591 10.3184 6.65128 9.79835 6.43427 8.53373C6.35196 8.03985 6.51659 7.53475 6.88325 7.16808C7.12271 6.93236 7.36591 6.79767 7.68019 6.73032C7.9421 6.67046 7.99074 6.67046 8.25264 6.71536ZM12.9669 7.13066C13.1091 7.20549 13.1802 7.32148 13.1802 7.50107V7.66944L10.3292 10.5242C8.58563 12.2677 7.42577 13.4052 7.3472 13.4388C7.08903 13.5511 6.81965 13.3603 6.81965 13.0647V12.9075L9.73053 10.0004C12.4094 7.31774 12.6489 7.08951 12.7611 7.08951C12.8285 7.08951 12.922 7.10821 12.9669 7.13066ZM12.3795 10.7337C13.1278 10.932 13.6441 11.6467 13.5805 12.3987C13.5244 13.0572 13.0867 13.6035 12.4506 13.8018C12.2935 13.8541 12.155 13.8654 11.9081 13.8541C11.62 13.8392 11.5414 13.8205 11.2982 13.7007C10.9577 13.5324 10.7145 13.2817 10.5499 12.9337C10.4377 12.698 10.4302 12.6569 10.4302 12.2715C10.4302 11.8786 10.4377 11.845 10.5574 11.598C10.9016 10.9021 11.6611 10.5429 12.3795 10.7337Z" fill="#F06724"/>
          <path d="M7.68023 7.56102C7.0554 7.83041 7.06288 8.75082 7.68771 9.01646C8.2003 9.22973 8.79894 8.84435 8.80268 8.29435C8.80642 7.73313 8.2003 7.33653 7.68023 7.56102Z" fill="#F06724"/>
          <path d="M11.8033 11.5045C11.5901 11.5532 11.3992 11.7103 11.2945 11.9198C11.1298 12.2528 11.1785 12.5746 11.4329 12.829C11.6948 13.0909 12.0203 13.1433 12.3533 12.9787C12.8285 12.7392 12.9333 12.1593 12.5741 11.7515C12.4656 11.6243 12.3758 11.5644 12.2336 11.5232C12.0278 11.4634 11.9867 11.4596 11.8033 11.5045Z" fill="#F06724"/>
        </svg>
        ${Shopify.formatMoney(discounted, moneyFormat)}
      </div>
      <span class="text-body-s">${isOrnament ? `each when buy ${items}` : '(After discount)'}</span>
  </div>`
}

function showToast(message) {
  const toast = document.getElementById('toast')
  if(!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  setTimeout(() => {
    toast.classList.remove('show');
  }, 2000);
}

// var formatWithCurrency = $('body').data('money-format');
 var formatWithCurrency = document.querySelector('body').dataset.moneyFormat;

function renderPriceSaleCollection(discount){
  if (!document.querySelector('#product-grid li.grid__item')) return;

  document.querySelectorAll('#product-grid li.grid__item').forEach(function(el) {
        var regular = el.querySelector('.price__regular .price-item.price-item--regular.money');

        if (regular) {
          var cents = parseInt(regular.getAttribute('data-price'), 10);
          if (!cents) return;
          var discounted = applyDisplayDiscount(cents, discount);
          var priceDiscount = Shopify.formatMoney(discounted, formatWithCurrency);

          var priceContainer = el.querySelector('.price__container');
          if (priceContainer) {
            priceContainer.insertAdjacentHTML('beforeend', getPriceDiscountCollections(priceDiscount));
          }
        }

        el.querySelectorAll('.box-price-final .price-item.price-item--regular.money').forEach(function(item) {
          item.classList.remove('hidden');
          item.classList.add('custom');
        });

        el.querySelectorAll('.box-price-final .price-item.price-item--sale.price-item--last.money').forEach(function(item) {
          item.classList.add('hidden');
        });
  });
}

function renderPriceProduct(discount,isOrnament = false , items = 0){
  var discounted = null;
  if (document.querySelector('.product-grid')) return;
  var moneyFormat = document.body.dataset.moneyFormat;

  document.querySelectorAll('.no-js-hidden[role="status"] .box-price-final .price-item.price-item--sale.price-item--last.money').forEach(function(el) {
        var raw = el.getAttribute('data-price') || el.dataset.price;
        var cents = raw ? parseInt(raw, 10) : null;
        if (!cents) return;

        discounted = applyDisplayDiscount(cents, discount);

        var priceContainer = document.querySelector(".no-js-hidden[role='status'] .price.price--large");
        if (priceContainer) {
          priceContainer.insertAdjacentHTML('beforeend', getPriceDiscountProduct(discounted, items, isOrnament));
        }

        document.querySelectorAll(".no-js-hidden[role='status'] .price__sale .box-price-final .price-item.price-item--sale.price-item--last.money").forEach(function(item) {
          item.classList.add('color-custom');
        });
        document.querySelectorAll(".no-js-hidden[role='status'] .price__sale .box-price-final .badge.price__badge-sale.color-accent-2").forEach(function(item) {
          item.classList.add('hidden');
        });
  });
  updatePricePack(discount)
}
function updatePricePack(discount) {
  // update price pack
  const currencyMapCart = {
    GBP: "£",
    EUR: "€",
    CAD: "$",
    AUD: "$",
    USD: "$"
  };
  document.querySelectorAll('.pack-custom').forEach(function(el) {
    const pack = el.getAttribute('data-pack-item');
    const price = el.getAttribute('data-price');
    const priceSale = applyDisplayDiscount(price, discount);
    const currencyCart = getCookieByProduct("cart_currency") || 'USD';
    const priceEl = el.querySelector('.pack-sub-content .pack-item-price');
    if (priceEl) {
      priceEl.textContent = Shopify.formatMoney(Math.ceil(priceSale / pack), `${currencyMapCart[currencyCart]}{{amount}}`);
    }
  });
}

const TIMES_TAMP_OFF_BFCM = 1766595599; // Dec 24 2024 23:59:59;

// check UTM for Meta Ads
function showUTMCartPage(itemDiscount){
  let showUTM = false;
  const code = itemDiscount.code;
  const discount = itemDiscount.discount;

  // handle logic show discount meta and google
  const cartItems = document.querySelectorAll('.cart-item');
  for (const el of cartItems) {
    const nameEl = el.querySelector('.cart-item__name');
    const productCollection = nameEl?.dataset.collection;
    const productType = nameEl?.dataset.productType;

    if (
      (itemDiscount?.ads === 'meta' && itemDiscount.collection?.includes(productCollection)) ||
      (itemDiscount?.ads === 'google' && itemDiscount.type?.includes(productType))
    ) {
      showUTM = true;
      break;
    }
  }

  //check hide BFCM
  let hideBFCM = false;
  for (const el of cartItems) {
    const nameEl = el.querySelector('.cart-item__name');
    const productType = nameEl?.dataset.productType;
    const productID = nameEl?.dataset.productId;

    if (
      (productType && TYPE_NOT_BFCM.includes(productType) && !PRODUCT_ID_BFCM.includes(Number(productID))) ||
      (!code && PRODUCT_ID_NOT_BFCM.includes(Number(productID)))
    ) {
      hideBFCM = true;
      break;
    }
  }

  //discount show ALL
  if(itemDiscount.collection == null && itemDiscount?.ads === 'meta' || itemDiscount.type == null && itemDiscount?.ads === 'google'){
    showUTM = true;
  }

  // hide discount BFCM -> do chứa product ẩn
  if(hideBFCM && (itemDiscount.collection != null && itemDiscount?.ads === 'meta' || itemDiscount.type != null && itemDiscount?.ads === 'google')) return

  if(itemDiscount?.items && itemDiscount?.price && showUTM){
    showDiscountHeader(code, 0, false, itemDiscount?.price, itemDiscount?.items);

    document.addEventListener('click', function(e) {
      const copyBtn = e.target.closest('.copy-discount');
      if (!copyBtn) return;
      const codeDiscount = copyBtn.getAttribute('data-code');
      if (codeDiscount) {
        navigator.clipboard.writeText(codeDiscount).then(() => {
          showToast('Code copied!');
        });
      }
    });

    //countdown
    countdownUTM();
    return;
  }else if(showUTM){
    showDiscountHeader(code,discount);

    document.addEventListener('click', function(e) {
      const copyBtn = e.target.closest('.copy-discount');
      if (!copyBtn) return;
      navigator.clipboard.writeText(code).then(() => {
        showToast('Code copied!');
      });
    });

    //countdown
    countdownUTM();
    return;
  }
  // show discount siteway
  handleDiscountBFCM();
}
function handleDiscountMetaVer2(params, itemDiscount){
    const pageCart = document.querySelector('body.cart');
    const utm = params.get('utm_discount');

    const utmValue = getCookieByProduct('utm_discount');

    // collection
    const collectionType = document.querySelector('.name-collection-page')?.textContent || null;
    const productCollection = document.querySelector('.collection-meta')?.textContent || '';

    let discount = utm?.match(regex)?.[1] || utm?.match(regex)?.[2] || utmValue?.match(regex)?.[1] || utmValue?.match(regex)?.[2]; 
    const matchValue = utm?.match(regex)?.[1] || utm?.match(regex)?.[2] || utmValue?.match(regex)?.[1] || utmValue?.match(regex)?.[2];

    if(itemDiscount){
      discount = itemDiscount.discount;
    }
   
    if(!discount){
      discount = 30;
    }

    if (
      !pageCart &&
      ((itemDiscount &&
        (itemDiscount.collection?.includes(productCollection) ||
          itemDiscount.collection?.includes(collectionType) ||
          itemDiscount.collection == null)) ||
        (!itemDiscount && matchValue && discountUTM?.find(item => item.code == (utm || utmValue))))
    ) {
      if((!utmValue || utm && utm != utmValue) && discountUTM?.find(item => item.code == utm)) {
          setCookieUTM('utm_discount', utm, 1)
      }

      let code = itemDiscount?.code || utm || utmValue;

      // hide Buy More Save More
      document.querySelectorAll('.sale-announcement').forEach(function(el) {
        el.classList.add('hidden');
      });

      if(itemDiscount?.items && itemDiscount?.price){
        // showDiscountOrnamentHeader(code, itemDiscount?.price, itemDiscount?.items);
        showDiscountHeader(code, 0, false, itemDiscount?.price, itemDiscount?.items)

        document.addEventListener('click', function(e) {
          var copyBtn = e.target.closest('.copy-discount');
          if (copyBtn) {
            navigator.clipboard.writeText(code).then(function() {
              showToast('Code copied!');
            });
          }
        });

        // page product
        renderPriceProduct(discount, true, itemDiscount?.items)
      }else{
        showDiscountHeader(code,discount);
        document.addEventListener('click', function(e) {
            if (e.target.closest('.copy-discount')) {
              navigator.clipboard.writeText(code).then(function() {
                showToast('Code copied!');
              });
            }
          });

        renderPriceProduct(discount)
      }

      //countdown
      countdownUTM();

      // page collection
      renderPriceSaleCollection(discount);

    }else if(pageCart && itemDiscount){
      showUTMCartPage(itemDiscount);
    }else{
      if (utm && utmValue && utmValue != utm) {
        let ITEM_DISCOUNT = discountUTM.find(item=>item.code == utmValue);
        let discount = ITEM_DISCOUNT?.discount
        let code = ITEM_DISCOUNT.code
          showDiscountHeader(code, discount);
          $(document).on("click",".copy-discount",function(){
            navigator.clipboard.writeText(code).then(() => {
              showToast('Code copied!');
            })
          })
          renderPriceProduct(discount)
          countdownUTM();
          renderPriceSaleCollection(discount);
          return;
      }
      handleDiscountBFCM();
    }
}
// check UTM for Google Ads
function handleDiscountGoogle(params, pricePopupCart = null) {
  const utmGoogle = params.getAll('utm_campaign');
  const pageCart = document.querySelector('body.cart');
  const productType = document.querySelector('.product-type')?.textContent || '';
  const collectionType = document.querySelector('.name-collection-page')?.textContent || '';

  let codeGG = undefined;
  let discountGG = undefined;
  const ruleMap = {};
  const DISCOUNT_MAP = {};
  const rules = {};

  // show discount by country
  const COUNTRY_CODE = document.body.getAttribute('country-code');
  
  if (COUNTRY_CODE === 'US') {
    ruleMap['21530399944'] = { discount: 20, code: "RM20GG" };
    ruleMap['24032376951'] = { discount: 20, code: "RM20GG" };
    ruleMap['24041855035'] = { discount: 20, code: "RM20GG" };
    ruleMap['24049196795'] = { discount: 20, code: "RM20GG" };

    ruleMap['21047190149'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['23297977638'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['23277787320'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['20877453289'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['23357105932'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['23357123020'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['20839862361'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['21052925518'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['22058378875'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['23430921035'] = { discount: 20, code: 'MA20SOGG' };
    ruleMap['23774306289'] = { discount: 20, code: 'MA20SOGG' };

    ruleMap['23364328009'] = { discount: 30, code: 'DCGG30' };
    ruleMap['23256396653'] = { discount: 30, code: 'DCGG30' };
    ruleMap['22054678793'] = { discount: 30, code: 'DCGG30' };
    ruleMap['21052925518'] = { discount: 30, code: 'DCGG30' };
    ruleMap['21989835023'] = { discount: 30, code: 'DCGG30' };

    ruleMap['21899173346'] = { discount: 50, code: 'DC50OR' };
    ruleMap['23793342621'] = { discount: 50, code: 'DC50OR' };

    DISCOUNT_MAP['RM20GG'] = 20;
    DISCOUNT_MAP['MA20SOGG'] = 20;
    DISCOUNT_MAP['DCGG30'] = 30;
    DISCOUNT_MAP['DC50OR'] = 50;
  }

  if (COUNTRY_CODE === 'AU') {
    ruleMap['23790546660'] = { discount: 10, code: 'AU10GG' };
    ruleMap['23790552600'] = [
      { discount: 10, code: 'AU10GG' },
      { discount: 18, code: 'AU18GGFF' },
      { discount: 25, code: 'GG25AU' },
    ];
    ruleMap['23948660804'] = [
      { discount: 10, code: 'AU10GG' },
      { discount: 18, code: 'AU18GGFF' },
      { discount: 25, code: 'GG25AU' },
    ];
    ruleMap['23795935157'] = [
      { discount: 10, code: 'AU10GG' },
      { discount: 18, code: 'AU18GGFF' },
      { discount: 25, code: 'GG25AU' },
    ];
    ruleMap['23847906388'] = [
      { discount: 18, code: 'AU18GGFF' },
      { discount: 25, code: 'GG25AU' },
    ];

    DISCOUNT_MAP['AU10GG'] = 10;
    DISCOUNT_MAP['AU18GGFF'] = 18;
    DISCOUNT_MAP['GG25AU'] = 25;
  }

  if (COUNTRY_CODE === 'GB') {
    ruleMap['23353250159'] = { discount: 20, code: 'UK2026' };
    ruleMap['23430870619'] = { discount: 20, code: 'UK2026' };
    ruleMap['23431413114'] = { discount: 20, code: 'UK2026' };
    ruleMap['23353266206'] = { discount: 20, code: 'UK2026' };
    ruleMap['23386357380'] = { discount: 20, code: 'UK2026' };
    ruleMap['23387330586'] = { discount: 20, code: 'UK2026' };
    ruleMap['23391450641'] = { discount: 20, code: 'UK2026' };
    ruleMap['23430080597'] = { discount: 20, code: 'UK2026' };
    ruleMap['23447870320'] = { discount: 20, code: 'UK2026' };
    ruleMap['20850048439'] = { discount: 20, code: 'UK2026' };
    DISCOUNT_MAP['UK2026'] = 20;
  }

  if (COUNTRY_CODE === 'CA') {
    ruleMap['17440002907'] = { discount: 10, code: 'CA10GG' };
    ruleMap['23753014502'] = { discount: 10, code: 'CA10GG' };
    ruleMap['23911016615'] = { discount: 10, code: 'CA10GG' };
    DISCOUNT_MAP['CA10GG'] = 10;
  }

  if (utmGoogle && utmGoogle.length > 0) {
    const matchedId = utmGoogle.find((id) => ruleMap[Number(id)]);
    if (matchedId) {
      const rule = ruleMap[matchedId];
      if (Array.isArray(rule)) {
        const matched = rule.find((r) =>
          discountUTM.find(
            (discount) => discount.code === r.code && discount.ads === 'google' && discount.type?.includes(productType),
          ),
        );

        if (matched) {
          discountGG = matched.discount;
          codeGG = matched.code;
        }
      } else {
        discountGG = ruleMap[matchedId].discount;
        codeGG = ruleMap[matchedId].code;
      }
    }
  }

  const utm_campaign = getCookieByProduct('utm_discount');
  if ((!utm_campaign && codeGG) || (codeGG && codeGG !== utm_campaign)) {
    const discountConfig = discountUTM.find(item => item.code === codeGG && item.ads === 'google');
    if (discountConfig && (!discountConfig.type || discountConfig.type.includes(productType))) {
      setCookieUTM('utm_discount', codeGG, 1);
    }
  }

  if (utm_campaign && !codeGG) {
    codeGG = utm_campaign;
    discountGG = DISCOUNT_MAP[utm_campaign] || 0;
  }
  if (!codeGG) {
    if (document.querySelectorAll('.promotion-box.custom-bfcm').length === 0) {
      handleDiscountBFCM();
    }
    return;
  }
  const getCollections = (code) => {
    const listType = discountUTM.find((item) => item.code === code);
    return listType ? listType.type : [];
  };

  const discountItem = discountUTM.find((item) => item.code === codeGG);
  if (discountItem && isDiscountAllowedForCountry(discountItem, COUNTRY_CODE)) {
    const types = getCollections(codeGG);
    rules[codeGG] = types ? types.includes(productType) : true;
  }
  if (rules[codeGG]) {
    if (pageCart) return;

    //show price popup Cart
    if (pricePopupCart && discountGG) {
      const cents = pricePopupCart ? parseInt(pricePopupCart, 10) : null;
      if (cents) {
        const priceSale = applyDisplayDiscount(cents, discountGG);
        document.querySelectorAll('p.price.price--large').forEach(function (el) {
          el.textContent = Shopify.formatMoney(priceSale, document.body.dataset.moneyFormat);
        });
        return;
      }
    }
    // hide Buy More Save More
    document.querySelectorAll('.sale-announcement').forEach(function (el) {
      el.classList.add('hidden');
    });
    showDiscountHeader(codeGG, discountGG);

    document.addEventListener('click', function (e) {
      if (e.target.closest('.copy-discount')) {
        navigator.clipboard.writeText(codeGG).then(() => {
          showToast('Code copied!');
        });
      }
    });

    //countdown
    countdownUTM();

    // render page collection
    // renderPriceSaleCollection(discountGG);

    // page product
    renderPriceProduct(discountGG);
  } else if (pageCart && utm_campaign) {
    const itemDiscount = discountUTM.find((item) => item.code === utm_campaign && item.ads === 'google');
    itemDiscount ? showUTMCartPage(itemDiscount) : handleDiscountBFCM();
  } else {
    handleDiscountBFCM();
  }
}


function handleDiscountBFCM() {
   // Hide BFCM MHS20
  // hide BFCM country UK
  const COUNTRY_CODE = document.body.getAttribute('country-code');
  const collectionDish = document.querySelector('.collection-meta-dish');
  const collection = document.querySelector('.name-collection-page');
  const params = new URLSearchParams(window.location.search);

  const utmMetaParam = params.get("utm_discount");    
  const utmGoogleParam = params.getAll('utm_campaign');
  const discountUTMStoredCookie  = getCookieByProduct('utm_discount');

  if(!discountUTMStoredCookie && !utmMetaParam && utmGoogleParam.length == 0 && COUNTRY_CODE == 'GB'){ 
    showDiscountFreeShipHeader();
    return
  }
}

document.addEventListener('DOMContentLoaded', function(){
  const params = new URLSearchParams(window.location.search);

   // ================= META INPUT (URL -> cookie -> fallback) =================
  const utmMetaParam = params.get("utm_discount");         
  const metaStoredCookie = getCookieByProduct("utm_discount");
  const validMeta = utmMetaParam?.match(regex)?.[1] || utmMetaParam?.match(regex)?.[2] || (!utmMetaParam && (metaStoredCookie?.match(regex)?.[1] || metaStoredCookie?.match(regex)?.[2]));
  
  // ================= Google INPUT (URL -> cookie -> fallback) ================= 
  const utmGoogleParam = params.getAll('utm_campaign');
  const discountGoogleStoredCookie  = getCookieByProduct('utm_discount');
  // ================= All INPUT (URL -> cookie -> fallback) ================= 
  const discountUTMStoredCookie  = getCookieByProduct('utm_discount');
  if(discountUTM){
    let ITEM_DISCOUNT = discountUTM.find(item=>item.code == utmMetaParam);
    const itemGG =  discountUTM.find(item=>item.code == discountUTMStoredCookie && item.ads =='google');
       
    if(ITEM_DISCOUNT && ITEM_DISCOUNT.ads == 'meta' && utmGoogleParam.length == 0 || !itemGG && utmGoogleParam.length == 0 
      || ITEM_DISCOUNT && ITEM_DISCOUNT.ads == 'meta' && utmGoogleParam.length == 1 && !CAMPAIGN_ADS_GOOGLE.includes(utmGoogleParam[0])
      || !ITEM_DISCOUNT && validMeta && utmGoogleParam.length == 0
    ){
      if(discountUTMStoredCookie && !utmMetaParam){
        ITEM_DISCOUNT = discountUTM.find(item=>item.code == discountUTMStoredCookie);
      }

      handleDiscountMetaVer2(params,ITEM_DISCOUNT);
      return
    }else if(utmGoogleParam && utmGoogleParam.length > 0 || discountUTMStoredCookie){
      handleDiscountGoogle(params);
      
      return
    }else{
      handleDiscountBFCM();
      return
    }
  }else{
    handleDiscountBFCM();
    return
  }
  
});
function updatePricePopupCart(cents, discount) {
  const priceSale = applyDisplayDiscount(cents, discount);
  const priceEl = document.querySelector('p.price.price--large');
  if (priceEl) {
    const moneyFormat = document.body.dataset.moneyFormat || document.body.getAttribute('data-money-format') || '';
    priceEl.textContent = Shopify.formatMoney(priceSale, moneyFormat);
  }
}

document.addEventListener('addToCartPopup', function(e) {
  const variant = e?.detail?.variant;
  const discountStoredCookie  = getCookieByProduct('utm_discount');
  const productType = document.querySelector('.product-type')?.textContent;
  const productID = document.querySelector('.product-id')?.textContent;
  const productCollection = document.querySelector('.collection-meta')?.textContent;
  const COUNTRY_CODE = document.body.getAttribute('country-code');
  const collectionDish = document.querySelector('.collection-meta-dish');
  const discount = discountStoredCookie?.match(regex)?.[1] || discountStoredCookie?.match(regex)?.[2];
  const isShowBFCM = collectionDish !== null;

  if(discountStoredCookie && variant?.price){
    const cents = parseInt(variant?.price, 10);
    const ITEM_DISCOUNT = discountUTM.find(item=>item.code == discountStoredCookie);

    if (!ITEM_DISCOUNT && discount) {
      if(cents && discount){
        updatePricePopupCart(cents,discount)
        return
      }
    }

    if(ITEM_DISCOUNT.ads == 'meta' && ITEM_DISCOUNT.collection?.includes(productCollection) || ITEM_DISCOUNT.ads == 'meta'  && ITEM_DISCOUNT.collection == null){
      if(cents && ITEM_DISCOUNT){
        updatePricePopupCart(cents,ITEM_DISCOUNT.discount)
        return
      }
    }else if(ITEM_DISCOUNT.ads == 'google' && ITEM_DISCOUNT.type?.includes(productType) || ITEM_DISCOUNT.ads == 'google' && ITEM_DISCOUNT.type == null && isDiscountAllowedForCountry(ITEM_DISCOUNT, COUNTRY_CODE)){

      if(cents && ITEM_DISCOUNT){
        updatePricePopupCart(cents,ITEM_DISCOUNT.discount)
        return
      }
    }

  }
  
  const elementPricePopupCart = document.querySelector('.item-atc p.price.price--large');
  const now = Math.floor(getCurrentLATime() / 1000);

  if (now < TIMES_TAMP_OFF_BFCM && variant?.price && isShowBFCM){
    const cents = variant?.price ? parseInt(variant?.price, 10) : null;
    if(cents){
      const priceSale = applyDisplayDiscount(cents, 20);
      elementPricePopupCart.textContent = Shopify.formatMoney(priceSale, document.body.dataset.moneyFormat);
    }
    return
  }
 
  if(elementPricePopupCart && variant?.price){
    elementPricePopupCart.textContent = Shopify.formatMoney(variant?.price, document.body.dataset.moneyFormat);
  }
});
// end show discount

// Mobile Filter Drawer Logic (Global)
document.addEventListener('click', function (event) {
  if (event.target.closest('.mc-all-filters-btn')) {
    var drawer = document.querySelector('menu-drawer.mc-mobile__wrapper');
    var details = drawer && drawer.querySelector('details');
    if (details) {
      details.open = true;
      if (drawer.openMenuDrawer) {
        drawer.openMenuDrawer(details.querySelector('summary'));
      }
    }
  }

  if (event.target.closest('.js-mobile-apply-btn') || event.target.closest('.mc-mobile-filters__cancel-btn')) {
    var drawer = document.querySelector('menu-drawer.mc-mobile__wrapper');
    if (drawer && drawer.mainDetailsToggle) {
      drawer.mainDetailsToggle.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-mobile');
      if (drawer.closeAnimation) {
        drawer.closeAnimation(drawer.mainDetailsToggle);
      }
    }
  }
});

document.querySelectorAll('[data-scroll-to]').forEach(function(el) {
  el.addEventListener('click', function(e) {
    var targetClass = el.getAttribute('data-scroll-to');
    if (!targetClass) return;
    var target = document.querySelector('.' + targetClass) || document.getElementById(targetClass);
    if (!target) return;
    e.preventDefault();
    var start = window.pageYOffset;
    var end = target.getBoundingClientRect().top + start;
    var duration = 800;
    var t0 = performance.now();
    (function step(now) {
      var p = Math.min((now - t0) / duration, 1);
      window.scrollTo(0, start + (end - start) * (p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2));
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  });
});

// Quantity box minus/plus buttons
document.addEventListener('click', function(e) {
  const qtyBoxBtn = e.target.closest('.button-minus-box, .button-plus-box');
  if (qtyBoxBtn) {
    const input = document.querySelector('input[name="quantity-box"]');
    if (input) {
      let qty = parseInt(input.value, 10) || 0;
      if (qtyBoxBtn.classList.contains('button-minus-box')) {
        if (qty > 1) qty--;
      } else {
        qty++;
      }
      input.value = qty;
    }
  }
});